/**
 * @quantbar/api-client
 *
 * Usage in any platform package:
 *
 *   import { createApiClient } from '@quantbar/api-client';
 *   import { localStorageAdapter } from '@quantbar/api-client';
 *
 *   // web (packages/web)
 *   const client = createApiClient(import.meta.env.VITE_API_URL, localStorageAdapter);
 *   const { apiRequest, handleApiError, getAuthToken, clearAuthToken } = client;
 *
 *   // React Native (packages/mobile) — provide your own adapter:
 *   import AsyncStorage from '@react-native-async-storage/async-storage';
 *   const rnAdapter = {
 *     getItem:    (key) => AsyncStorage.getItem(key),
 *     setItem:    (key, val) => AsyncStorage.setItem(key, val),
 *     removeItem: (key) => AsyncStorage.removeItem(key),
 *   };
 *   const client = createApiClient(process.env.EXPO_PUBLIC_API_URL, rnAdapter);
 */

export { createBaseClient } from './base.js';
export type { ApiClientConfig, ApiRequestOptions, ApiError } from './base.js';

export { localStorageAdapter } from './StorageAdapter.js';
export type { StorageAdapter } from './StorageAdapter.js';

import { createBaseClient } from './base.js';
import type { StorageAdapter } from './StorageAdapter.js';

/**
 * Convenience factory — thin alias over createBaseClient.
 */
export function createApiClient(baseUrl: string, storage: StorageAdapter) {
  return createBaseClient({ baseUrl, storage });
}
